/**
 * Manual de Usuario - JavaScript para Interactividad
 * ==================================================
 */

document.addEventListener('DOMContentLoaded', function() {
  initializeUserManual();
});

function initializeUserManual() {
  // Solo ejecutar en páginas del manual de usuario
  if (!document.querySelector('.user-manual-container')) return;

  initializeSearch();
  initializeNavigation();
  initializeUI();
  initializeAccessibility();
}

/**
 * Funcionalidad de búsqueda
 */
function initializeSearch() {
  const searchForm = document.getElementById('manual-search-form');
  const searchInput = document.querySelector('.manual-search-input');
  const searchResults = document.getElementById('search-results-container');
  let searchTimeout;
  let searchCache = new Map();

  if (searchInput) {
    // Búsqueda en tiempo real
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const query = this.value.trim();
      
      if (query.length >= 2) {
        searchTimeout = setTimeout(() => performSearch(query), 300);
      } else {
        hideSearchResults();
      }
    });

    // Manejo del formulario de búsqueda
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query.length >= 2) {
          performSearch(query, true);
        }
      });
    }

    // Atajos de teclado para búsqueda
    document.addEventListener('keydown', function(e) {
      // Ctrl/Cmd + K para enfocar búsqueda
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        searchInput.focus();
        searchInput.select();
      }
      
      // Escape para cerrar resultados de búsqueda
      if (e.key === 'Escape' && searchResults && !searchResults.classList.contains('d-none')) {
        hideSearchResults();
        searchInput.blur();
      }
    });
  }

  function performSearch(query, navigate = false) {
    // Verificar caché
    const cacheKey = query.toLowerCase();
    if (searchCache.has(cacheKey) && !navigate) {
      showSearchResults(searchCache.get(cacheKey));
      return;
    }

    // Mostrar indicador de carga
    showSearchLoading();

    const formData = new FormData();
    formData.append('q', query);
    
    const categorySelect = document.querySelector('.manual-category-select');
    if (categorySelect && categorySelect.value) {
      formData.append('category', categorySelect.value);
    }

    const params = new URLSearchParams(formData);

    fetch(`/manual/search?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': getCSRFToken()
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      searchCache.set(cacheKey, data);
      if (navigate) {
        window.location.href = `/manual/search?q=${encodeURIComponent(query)}`;
      } else {
        showSearchResults(data);
      }
    })
    .catch(error => {
      console.error('Error de búsqueda:', error);
      showSearchError();
    });
  }

  function showSearchResults(data) {
    if (!searchResults) return;

    const resultsHTML = generateSearchResultsHTML(data);
    searchResults.innerHTML = resultsHTML;
    searchResults.classList.remove('d-none');
    
    // Añadir event listeners a los resultados
    attachSearchResultEvents();
  }

  function generateSearchResultsHTML(data) {
    if (!data.results || data.results.length === 0) {
      return `
        <div class="search-dropdown-empty">
          <i class="fa-solid fa-search fa-2x text-muted mb-2"></i>
          <p class="text-muted mb-0">No se encontraron resultados</p>
        </div>
      `;
    }

    let html = `
      <div class="search-dropdown-header">
        <small class="text-muted">${data.total} resultado${data.total !== 1 ? 's' : ''} encontrado${data.total !== 1 ? 's' : ''}</small>
      </div>
    `;

    data.results.slice(0, 5).forEach(result => {
      html += `
        <div class="search-dropdown-item" data-url="${result.url}">
          <div class="search-item-category">
            <small class="badge bg-primary">${result.category}</small>
          </div>
          <div class="search-item-title">${result.title}</div>
          <div class="search-item-excerpt">${result.excerpt}</div>
        </div>
      `;
    });

    if (data.total > 5) {
      html += `
        <div class="search-dropdown-footer">
          <a href="/manual/search?q=${encodeURIComponent(searchInput.value)}" class="btn btn-sm btn-outline-primary w-100">
            Ver todos los ${data.total} resultados
          </a>
        </div>
      `;
    }

    return html;
  }

  function attachSearchResultEvents() {
    const items = document.querySelectorAll('.search-dropdown-item[data-url]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        window.location.href = this.dataset.url;
      });
    });
  }

  function showSearchLoading() {
    if (!searchResults) return;
    
    searchResults.innerHTML = `
      <div class="search-dropdown-loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span class="ms-2">Buscando...</span>
      </div>
    `;
    searchResults.classList.remove('d-none');
  }

  function showSearchError() {
    if (!searchResults) return;
    
    searchResults.innerHTML = `
      <div class="search-dropdown-error">
        <i class="fa-solid fa-exclamation-triangle text-warning"></i>
        <span class="ms-2">Error en la búsqueda. Inténtalo nuevamente.</span>
      </div>
    `;
  }

  function hideSearchResults() {
    if (searchResults) {
      searchResults.classList.add('d-none');
    }
  }
}

/**
 * Funcionalidad de navegación
 */
function initializeNavigation() {
  // Navegación con teclado entre secciones
  document.addEventListener('keydown', function(e) {
    // Solo en páginas de sección individual
    if (!document.querySelector('.manual-section-content')) return;
    
    const prevBtn = document.querySelector('.btn-nav-prev');
    const nextBtn = document.querySelector('.btn-nav-next');
    
    // Alt + Left Arrow = Sección anterior
    if (e.altKey && e.key === 'ArrowLeft' && prevBtn) {
      e.preventDefault();
      window.location.href = prevBtn.href;
    }
    
    // Alt + Right Arrow = Sección siguiente
    if (e.altKey && e.key === 'ArrowRight' && nextBtn) {
      e.preventDefault();
      window.location.href = nextBtn.href;
    }
  });

  // Scroll suave para enlaces internos
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Indicador de progreso de lectura
  initializeReadingProgress();
}

function initializeReadingProgress() {
  const content = document.querySelector('.manual-section-content');
  if (!content) return;

  // Crear barra de progreso
  const progressBar = document.createElement('div');
  progressBar.className = 'reading-progress';
  progressBar.innerHTML = '<div class="reading-progress-bar"></div>';
  
  // Añadir estilos
  const style = document.createElement('style');
  style.textContent = `
    .reading-progress {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background: rgba(52, 152, 219, 0.2);
      z-index: 9999;
    }
    .reading-progress-bar {
      height: 100%;
      background: #3498db;
      width: 0%;
      transition: width 0.2s ease;
    }
  `;
  document.head.appendChild(style);
  document.body.appendChild(progressBar);

  const progressBarFill = progressBar.querySelector('.reading-progress-bar');

  function updateProgress() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight - windowHeight;
    const scrollTop = window.pageYOffset;
    const progress = Math.min((scrollTop / documentHeight) * 100, 100);
    
    progressBarFill.style.width = progress + '%';
  }

  window.addEventListener('scroll', updateProgress);
  updateProgress(); // Calcular progreso inicial
}

/**
 * Mejoras de UI
 */
function initializeUI() {
  // Funcionalidad de compartir
  const shareBtn = document.getElementById('share-btn');
  if (shareBtn) {
    shareBtn.addEventListener('click', handleShare);
  }

  // Tooltips para botones
  initializeTooltips();

  // Animaciones de entrada
  initializeAnimations();

  // Funcionalidad de impresión mejorada
  initializePrint();
}

function handleShare() {
  const title = document.querySelector('.section-title, .manual-title')?.textContent || 'Manual de Usuario';
  const url = window.location.href;

  if (navigator.share) {
    navigator.share({
      title: title,
      url: url
    }).catch(err => console.log('Error sharing:', err));
  } else {
    // Fallback: copiar URL
    navigator.clipboard.writeText(url).then(() => {
      showNotification('URL copiada al portapapeles', 'success');
    }).catch(err => {
      console.error('Error copying to clipboard:', err);
      showNotification('No se pudo copiar la URL', 'error');
    });
  }
}

function initializeTooltips() {
  // Inicializar tooltips de Bootstrap si están disponibles
  if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  }
}

function initializeAnimations() {
  // Animaciones de entrada con Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, { threshold: 0.1 });

  // Observar elementos que deben animarse
  document.querySelectorAll('.manual-card, .manual-category-card, .search-result-item').forEach(el => {
    observer.observe(el);
  });

  // Añadir estilos de animación
  const animationStyle = document.createElement('style');
  animationStyle.textContent = `
    .manual-card, .manual-category-card, .search-result-item {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease, transform 0.6s ease;
    }
    .animate-in {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(animationStyle);
}

function initializePrint() {
  // Mejorar la funcionalidad de impresión
  const printBtns = document.querySelectorAll('[href*="/print"]');
  
  printBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Abrir en nueva ventana con configuración optimizada para impresión
      const printWindow = window.open(
        this.href,
        'print-window',
        'width=800,height=600,scrollbars=yes,resizable=yes'
      );
      
      if (printWindow) {
        printWindow.addEventListener('load', function() {
          setTimeout(() => {
            printWindow.print();
          }, 500);
        });
      }
    });
  });
}

/**
 * Mejoras de accesibilidad
 */
function initializeAccessibility() {
  // Navegación con teclado mejorada
  document.addEventListener('keydown', function(e) {
    // Tab navigation hints
    if (e.key === 'Tab') {
      document.body.classList.add('keyboard-navigation');
    }
  });

  document.addEventListener('mousedown', function() {
    document.body.classList.remove('keyboard-navigation');
  });

  // Añadir estilos de accesibilidad
  const a11yStyle = document.createElement('style');
  a11yStyle.textContent = `
    .keyboard-navigation *:focus {
      outline: 2px solid #3498db !important;
      outline-offset: 2px !important;
    }
    
    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
      }
    }
  `;
  document.head.appendChild(a11yStyle);

  // Skip links para navegación
  addSkipLinks();
}

function addSkipLinks() {
  const skipLinks = document.createElement('div');
  skipLinks.className = 'skip-links';
  skipLinks.innerHTML = `
    <a href="#main-content" class="skip-link">Saltar al contenido principal</a>
    <a href="#manual-search" class="skip-link">Saltar a la búsqueda</a>
  `;

  const skipStyle = document.createElement('style');
  skipStyle.textContent = `
    .skip-links {
      position: absolute;
      top: -100px;
      left: 0;
      z-index: 10000;
    }
    .skip-link {
      position: absolute;
      top: 100px;
      left: 20px;
      background: #000;
      color: #fff;
      padding: 10px;
      text-decoration: none;
      border-radius: 4px;
      opacity: 0;
      transition: opacity 0.3s;
    }
    .skip-link:focus {
      opacity: 1;
      top: 10px;
    }
  `;
  
  document.head.appendChild(skipStyle);
  document.body.insertBefore(skipLinks, document.body.firstChild);
}

/**
 * Utilidades
 */
function getCSRFToken() {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token ? token.getAttribute('content') : '';
}

function showNotification(message, type = 'info', duration = 3000) {
  // Crear notificación
  const notification = document.createElement('div');
  notification.className = `alert alert-${type} alert-dismissible fade show manual-notification`;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    max-width: 300px;
    animation: slideInRight 0.3s ease;
  `;
  
  notification.innerHTML = `
    ${message}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  `;
  
  document.body.appendChild(notification);
  
  // Auto-dismiss
  setTimeout(() => {
    notification.style.animation = 'slideOutRight 0.3s ease';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }, duration);

  // Añadir estilos de animación si no existen
  if (!document.querySelector('#notification-animations')) {
    const animStyle = document.createElement('style');
    animStyle.id = 'notification-animations';
    animStyle.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOutRight {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(animStyle);
  }
}

// Exponer funciones globalmente para uso en vistas
window.ManualJS = {
  showNotification,
  getCSRFToken,
  handleShare
};

export { 
  initializeUserManual, 
  showNotification, 
  getCSRFToken, 
  handleShare 
};
